/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  BulkCardCreateResponse,
  CardLimitsTotal,
  CardLimitsTotalRequestDto,
  CardOrderResponse,
  CardResponse,
  CreateBulkCardsRequest,
  CreateBulkCardsRequestV2,
  CreateCardRequest,
  CreateMigrationV2Payload,
  CreateSubscriptionMigrationCardsPayload,
  CreateSubscriptionMigrationRequest,
  GetCard1Params,
  GetMerchantCategoriesParams,
  GetSubscriptionMigrationsParams,
  MigrationCardResponse,
  MigrationCardUpdateRequestDto,
  SubscriptionCardOrderResponseDto,
  SubscriptionMigrationDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiCardsV2Controller<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name CreateBulkCards
   * @request POST:/api/v2/users/bulk-cards
   */
  createBulkCards = (data: CreateBulkCardsRequest, params: RequestParams = {}) =>
    this.http.request<CardOrderResponse[], any>({
      path: `/v2/users/bulk-cards`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createBulkCardsPath = '/v2/users/bulk-cards'
  static createBulkCardsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name CreateCard
   * @request POST:/api/v2/user/{userId}/card
   */
  createCard = (userId: string, data: CreateCardRequest, params: RequestParams = {}) =>
    this.http.request<CardOrderResponse, any>({
      path: `/v2/user/${userId}/card`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createCardPath = '/v2/user/${userId}/card'
  static createCardMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name GetSubscriptionMigrations
   * @request GET:/api/v2/subscription-migrations
   */
  getSubscriptionMigrations = (
    query: GetSubscriptionMigrationsParams,
    params: RequestParams = {},
  ) =>
    this.http.request<SubscriptionMigrationDto[], any>({
      path: `/v2/subscription-migrations`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getSubscriptionMigrationsPath = '/v2/subscription-migrations'
  static getSubscriptionMigrationsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name CreateMigration
   * @request POST:/api/v2/subscription-migrations
   */
  createMigration = (data: CreateSubscriptionMigrationRequest, params: RequestParams = {}) =>
    this.http.request<SubscriptionMigrationDto, any>({
      path: `/v2/subscription-migrations`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createMigrationPath = '/v2/subscription-migrations'
  static createMigrationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name CreateSubscriptionMigrationCards
   * @request POST:/api/v2/subscription-migrations/{subscriptionMigrationRequestId}/cards
   */
  createSubscriptionMigrationCards = (
    subscriptionMigrationRequestId: string,
    data: CreateSubscriptionMigrationCardsPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<SubscriptionCardOrderResponseDto[], any>({
      path: `/v2/subscription-migrations/${subscriptionMigrationRequestId}/cards`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createSubscriptionMigrationCardsPath =
    '/v2/subscription-migrations/${subscriptionMigrationRequestId}/cards'
  static createSubscriptionMigrationCardsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name CreateMigrationV2
   * @request POST:/api/v2/subscription-migrations/v2
   */
  createMigrationV2 = (data: CreateMigrationV2Payload, params: RequestParams = {}) =>
    this.http.request<SubscriptionMigrationDto, any>({
      path: `/v2/subscription-migrations/v2`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createMigrationV2Path = '/v2/subscription-migrations/v2'
  static createMigrationV2Method = 'POST'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name CreateCards
   * @request POST:/api/v2/requests/bulk-cards
   */
  createCards = (data: CreateBulkCardsRequestV2, params: RequestParams = {}) =>
    this.http.request<BulkCardCreateResponse, any>({
      path: `/v2/requests/bulk-cards`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createCardsPath = '/v2/requests/bulk-cards'
  static createCardsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name UpdateMigrationCards
   * @request POST:/api/v2/merchant-migrations/{migrationId}/migration-cards/update
   */
  updateMigrationCards = (
    migrationId: string,
    data: MigrationCardUpdateRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v2/merchant-migrations/${migrationId}/migration-cards/update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateMigrationCardsPath = '/v2/merchant-migrations/${migrationId}/migration-cards/update'
  static updateMigrationCardsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name CompleteMigration
   * @request POST:/api/v2/merchant-migrations/{migrationId}/complete
   */
  completeMigration = (
    migrationId: string,
    data: MigrationCardUpdateRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v2/merchant-migrations/${migrationId}/complete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static completeMigrationPath = '/v2/merchant-migrations/${migrationId}/complete'
  static completeMigrationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name CalculateCardLimitsTotal
   * @request POST:/api/v2/card-limits/organisation/total
   */
  calculateCardLimitsTotal = (data: CardLimitsTotalRequestDto, params: RequestParams = {}) =>
    this.http.request<CardLimitsTotal, any>({
      path: `/v2/card-limits/organisation/total`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static calculateCardLimitsTotalPath = '/v2/card-limits/organisation/total'
  static calculateCardLimitsTotalMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name GetSubscriptionMigrationCardOrders
   * @request GET:/api/v2/subscription-migrations/{subscriptionMigrationRequestId}/card-orders
   */
  getSubscriptionMigrationCardOrders = (
    subscriptionMigrationRequestId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<SubscriptionCardOrderResponseDto[], any>({
      path: `/v2/subscription-migrations/${subscriptionMigrationRequestId}/card-orders`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getSubscriptionMigrationCardOrdersPath =
    '/v2/subscription-migrations/${subscriptionMigrationRequestId}/card-orders'
  static getSubscriptionMigrationCardOrdersMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name GetMigrationCards
   * @request GET:/api/v2/merchant-migrations/{migrationId}/migration-cards
   */
  getMigrationCards = (migrationId: string, params: RequestParams = {}) =>
    this.http.request<MigrationCardResponse, any>({
      path: `/v2/merchant-migrations/${migrationId}/migration-cards`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getMigrationCardsPath = '/v2/merchant-migrations/${migrationId}/migration-cards'
  static getMigrationCardsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name GetCard1
   * @request GET:/api/v2/card/{cardId}
   */
  getCard = ({ cardId, ...query }: GetCard1Params, params: RequestParams = {}) =>
    this.http.request<CardResponse, any>({
      path: `/v2/card/${cardId}`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getCardPath = '/v2/card/${cardId}'
  static getCardMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name GetMerchantCategories
   * @request GET:/api/v2/card-limits/merchant-categories
   */
  getMerchantCategories = (query: GetMerchantCategoriesParams, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/v2/card-limits/merchant-categories`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getMerchantCategoriesPath = '/v2/card-limits/merchant-categories'
  static getMerchantCategoriesMethod = 'GET'
}
